<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { Tab } from './appTypes.js';

    export let tabs: Tab[] = [];
    export let value: string = '';

    const dispatch = createEventDispatcher();

    function select(tabValue: string) {
        value = tabValue;
        dispatch('change', tabValue);
    }

    function onKeydown(e: KeyboardEvent, tabValue: string) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            select(tabValue);
        }
    }
</script>

<div class="tab-bar" role="tablist">
    {#each tabs as tab (tab.value)}
        <button
            type="button"
            role="tab"
            class="tab"
            class:active={value === tab.value}
            aria-selected={value === tab.value}
            tabindex={value === tab.value ? 0 : -1}
            on:click={() => select(tab.value)}
            on:keydown={(e) => onKeydown(e, tab.value)}
        >
            {#if tab.icon}<i class="{tab.icon} icon" aria-hidden="true"></i>{/if}
            <span>{tab.label}</span>
        </button>
    {/each}
</div>

<style>
    .tab-bar {
        display: flex;
        gap: var(--space-1);
        border-bottom: 1px solid var(--border-color);
        margin-bottom: var(--space-5);
    }

    .tab {
        display: inline-flex;
        align-items: center;
        gap: var(--space-2);
        padding: var(--space-3) var(--space-4);
        background: transparent;
        border: none;
        border-bottom: 2px solid transparent;
        color: var(--grey-secondary);
        cursor: pointer;
        font-weight: 500;
        font-size: var(--text-sm);
    }

    .tab:hover { color: var(--grey); }
    .tab.active { color: var(--primary); border-bottom-color: var(--primary); }
    .tab:focus-visible { outline: none; box-shadow: var(--focus-ring); border-radius: var(--radius-input); }
</style>
